<template>
    <div class="current">
        <Bread :title1="'Личный кабинет'" :title2="'Текущие заказы'"/> 
        <div class="current__title">
            <p>Текущие заказы</p>
        </div>
        <div class="current__orders" v-if="groupedOrders && Object.keys(groupedOrders).length > 0">
            <div class="current__order-group" 
                v-for="orderId in Object.keys(groupedOrders).reverse()" 
                :key="orderId">
                <div class="current__order-group__header">
                    <p>Заказ №{{ orderId }}</p>
                    <p class="current__order-group__header__status" 
                       :class="{'paid': isOrderPaid(groupedOrders[orderId]), 'unpaid': !isOrderPaid(groupedOrders[orderId])}">
                        {{ isOrderPaid(groupedOrders[orderId]) ? 'Оплачен' : 'Ожидает' }}
                    </p>
                    
                </div>
                <div class="current__order-info">
                    <div class="current__order-info__row">
                        <span> {{ groupedOrders[orderId][0].user_type === 0 ? 'Физ. Лицо' : 'Юр. Лицо' }}</span>
                    </div>
                    <div class="current__order-info__row">
                        <span>Способ оплаты:</span>
                        <span> {{ getPaymentMethod(groupedOrders[orderId][0].payment_method) }}</span>
                    </div>
                    <div class="current__order-info__row">
                        <span>Способ доставки:</span>
                        <span> {{ getDeliveryType(groupedOrders[orderId][0].delivery_type) }}</span>
                    </div>
                    <div class="current__order-info__row" v-if="groupedOrders[orderId][0].address">
                        <span>Адрес доставки:</span>
                        <span> {{ groupedOrders[orderId][0].address }}</span>
                    </div>
                </div>
                <div class="current__order-group__items">
                    <div class="current__orders__in" v-for="item in groupedOrders[orderId]" :key="item.id" 
                         @click="$router.push({ name: 'cardBySlug', params: { slug: item.slug } })">
                        <img :src="item.image" class="current__orders__in__img" />
                        <p class="current__orders__in__title">{{ item.title }}</p>
                        <p>Артикул: {{ item.vendor_code }}</p>
                        <div class="current__orders__in__1">
                            <p>В наличии</p>
                            <img src="@/assets/icons/ok.svg" />
                        </div>
                        <p class="current__orders__in__price">{{ formatPrice(item.price) }}</p>
                    </div>
                </div>
                <div class="current__order-group__footer">
                    <button v-if="!isOrderPaid(groupedOrders[orderId]) && groupedOrders[orderId][0].payment_method === 0 && groupedOrders[orderId][0].user_type === 0" 
                            @click="fetchNewPay(orderId);" 
                            style="cursor: pointer">
                            Перейти к оплате
                    </button>
                    <div v-else></div>
                    <p>Итого: {{ formatPrice(calculateOrderTotal(groupedOrders[orderId])) }}</p>
                </div>
            </div>
        </div>  
        <div class="current__not" v-else>
            <p>У вас нет текущих заказов</p>
        </div>
    </div>
</template>

<script>
import Bread from './Bread.vue';
import CardProduct from '@/components/CardProduct.vue';
import { toast } from "vue3-toastify";

export default {
    data() {
        return {
            newCurrents: [],
            paymentMethods: {
                0: 'Банковской картой',
                1: 'Наличными курьеру'
            },
            deliveryTypes: {
                0: 'Доставка до адреса',
                1: 'Самовывоз'
            }
        }
    },
    components: {
        Bread, CardProduct
    },
    computed: {
        groupedOrders() {
            if (!this.newCurrents || this.newCurrents.length === 0) return {};
            const groups = {};
            this.newCurrents.forEach(item => {
                if (!groups[item.order_id]) {
                    groups[item.order_id] = [];
                }
                groups[item.order_id].push(item);
            });
            return groups;
        }
    },
    async created() {
        this.getPage();
    },
    methods: {
        async getPage() {    
            await this.$axios.get(`orders/current`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.newCurrents = res.data.orderProducts.data;
            })
            .catch(err => {
                console.error(err);
            });        
        },
        formatPrice(price) {
            const number = parseFloat(price);
            if (isNaN(number)) return 'Цена не указана';
            return number.toLocaleString('ru-RU') + ' ₸';
        },
        calculateOrderTotal(items) {
            return items.reduce((total, item) => total + parseFloat(item.price), 0);
        },
        isOrderPaid(items) {
            return items.every(item => item.payment_status === 1);
        },
        getPaymentMethod(methodId) {
            return this.paymentMethods[methodId] || 'Не указан';
        },
        getDeliveryType(typeId) {
            return this.deliveryTypes[typeId] || 'Не указан';
        },
        async setNewPaymentToken(orderId) {
            try {
                const response = await this.$axios.get("https://admin.hayward.kz/api/V1/orders/new-token", {
                    params: {
                        order_id: orderId
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                });
                if (response.status === 201) {
                    // Добавить новую группу в массив после успешного ответа
                    toast("Успешно отправлено");
                    this.$store.state.openBasket = "issued";
                    return response.data.data;
                } else {
                    toast(err?.response?.data?.message);
                }
            } catch (error) {
                console.error(error);
            }
        },
        async fetchNewPay(orderId) {
            let newPay = await this.setNewPaymentToken(orderId);
            if (!newPay) return;
            let auth = newPay.token;
            let invoiceId = newPay.invoice_id;
            let amount = newPay.amount;
            halyk.showPaymentWidget(this.createPaymentObject(auth, invoiceId, amount), (res) => {
                if (res.success) {
                    this.isEnterBalance = false;
                    location.reload();
                }
            });
        },
        createPaymentObject(auth, invoiceId, amount) {
            let paymentObject = {
                invoiceId: invoiceId,
                backLink: "",
                failureBackLink: "",
                postLink: "https://admin.hayward.kz/api/V1/orders/payment-success",
                failurePostLink: "https://admin.hayward.kz/api/V1/orders/payment-failed",
                language: this.lang === "ru",
                description: "Оплата товара",
                accountId: "HAYWARD.KZ",
                terminal: "4c9c1a17-b501-4cae-8455-346f89f09071", // "67e34d63-102f-4bd1-898e-370781d0074d",
                amount: amount,
                currency: "KZT",
                // data: '{"statement":{"name":"Arman     Ali","invoiceID":"80000016"}}',
                cardSave: false, //Параметр должен передаваться как Boolean
            };
            paymentObject.auth = auth;
            return paymentObject;
        },
    }
}
</script>
<style lang="scss" scoped>
    .current{
        display: flex;
        flex-direction: column;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 1.3021))), 30px);
        button {
            width: 30%;
            background: #006495;
            border: none;
            color: white;
            border-radius: 5px;
            padding: min(max(7px, calc(0.4375rem + ((1vw - 7.68px) * 0.434))), 12px) 0px;
            font-size: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 0.5208))), 18px);
            @media (max-width: 768px) {
                font-size: 13px;
            }
        }

        &__title{
            color: #363636;
            font-size: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.7813))), 24px);
            @media(max-width:768px){
                font-size: 15px;
            }
        }
        &__not{
            font-size: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 0.5208))), 18px);
            @media(max-width:768px){
                font-size: 14px;
            }
        }
          
        &__order-info {
            background: #f5f5f5;
            border-radius: 8px;
            padding: 15px;
            margin-bottom: 20px;
            
            &__row {
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
                font-size: 14px;
                
                span:first-child {
                    color: #666;
                }
                
                span:last-child {
                    font-weight: 500;
                    color: #333;
                }
            }
        }
        &__order-group {
            border: 1px solid #e0e0e0;
            border-radius: 10px;
            padding: 20px;
            margin-bottom: 30px;
            background: #f9f9f9;
            
            &__header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 1px solid #e0e0e0;
                
                p {
                    font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.5208))), 20px);
                    font-weight: bold;
                    color: #363636;
                }
                
                &__status {
                    padding: 5px 10px;
                    border-radius: 5px;
                    font-size: 14px;
                    
                    &.paid {
                        background: #e6f7ee;
                        color: #00a854;
                    }
                    
                    &.unpaid {
                        background: #fff7e6;
                        color: #fa8c16;
                    }
                }
            }
            
            
            &__items {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(min(max(150px, calc(9.375rem + ((1vw - 7.68px) * 8.6806))), 250px), 1fr));
                gap: min(max(30px, calc(1.875rem + ((1vw - 7.68px) * 2.6042))), 60px);
                row-gap: min(max(25px, calc(1.5625rem + ((1vw - 7.68px) * 2.1701))), 50px);
            }
            
            &__footer {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                padding-top: 10px;
                border-top: 1px solid #e0e0e0;
                text-align: right;
                font-weight: bold;
                font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.5208))), 20px);
            }
        }
        
        &__orders__in{
            border: 1px solid #0000001A;
            border-radius: 10px;
            padding: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 1.1285))), 25px);
            display: flex;
            flex-direction: column;
            gap: min(max(7px, calc(0.4375rem + ((1vw - 7.68px) * 0.434))), 12px);
            font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.5208))), 15px);
            color: #00000080;
            cursor: pointer;
            transition: all 0.5s ease;
            background: white;
            
            @media(max-width:768px){
                font-size: 14px;
            }
            
            &:hover{
                transform: scale(1.05);
            }
            
            &__img{
                width: 100%;
                aspect-ratio: 1;
            }
            
            &__title{
                flex-grow: 1;
                color: #232F3E;
            }
            
            &__1{
                display: flex;
                gap: 10px;
            }
            
            &__price{
                font-size: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 0.5208))), 18px) !important;
                color: black !important;
                @media(max-width:768px){
                    font-size: 14px !important;
                }
            }
            
            &__bot{
                display: flex;
                justify-content: center;
                align-items: center;
                color: rgba(56, 44, 44, 0.479);
            }
        }
    }
</style>